import React from "react";
import { BiErrorCircle } from "react-icons/bi";

interface AlertProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  message: string;
  singleButton?: boolean;
}

const AlertPerigo: React.FC<AlertProps> = ({
  isOpen,
  onClose,
  onConfirm,
  message,
  singleButton = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="bg-red-500/90 text-white rounded-lg shadow-lg max-w-md w-full p-6 animate-fade-in">
        <div className="flex items-center gap-3 mb-4">
          <BiErrorCircle className="w-6 h-6 text-white" />
          <h2 className="text-base sm:text-lg font-semibold">{message}</h2>
        </div>
        <div className="flex justify-end gap-3 mt-4">
          {singleButton ? (
            <button
              onClick={onClose}
              className="px-4 py-2 bg-white text-red-600 font-semibold rounded hover:bg-red-100 transition"
            >
              OK
            </button>
          ) : (
            <>
              <button
                onClick={onConfirm}
                className="px-4 py-2 bg-white text-red-600 font-semibold rounded hover:bg-red-100 transition"
              >
                Confirmar
              </button>
              <button
                onClick={onClose}
                className="px-4 py-2 bg-red-700/80 text-white font-semibold rounded hover:bg-red-600 transition"
              >
                Cancelar
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AlertPerigo;
